export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SET_USER_ROLE = "SET_USER_ROLE";
export const SET_AUTH_READY = "SET_AUTH_READY";

export const setUserRole = (rol: string) => ({
	type: SET_USER_ROLE,
	payload: rol,
});

export const setUser = (name: string) => ({
	type: SET_USER,
    payload: name
});

export const clearUser = () => ({
	type: CLEAR_USER,
});

export const setAuthReady = (ready: boolean) => ({
	type: SET_AUTH_READY,
	payload: ready
});
